module.exports = __webpack_public_path__ + "static/media/offerBg1.2c90aa60.svg";